import WidgetHeader from './WidgetHeader';
export default WidgetHeader;



// WEBPACK FOOTER //
// ./src/components/WidgetHeader/index.js